const profilesLimit = 700;

export default profilesLimit;
